import React from 'react';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import FirebaseStore from 'stores/FirebaseStore';
import GroupShowStore from 'stores/GroupShowStore';

import groupShowTicketImage from '../../../images/gs-icon.png';
import lockedChatImg from '../../../images/lockedChat.png';

import styles from './DesktopBroadcastLockedChat.css';


const DesktopBroadcastLockedChat = () => {
  const { userKickedStatus, userBannedStatus } = FirebaseStore;
  const { broadcasterInsideGroupShow } = GroupShowStore;

  let imageSrc = lockedChatImg;
  if (broadcasterInsideGroupShow) {
    imageSrc = groupShowTicketImage;
  }

  return (
    <div className={styles.lockedChatWrapper}>
      <img alt="" src={imageSrc} />

      {userKickedStatus || userBannedStatus ? (
        <p className={styles.unavailableMsg}>
          {translate('v2profile.chat.unavailable.message')}
        </p>
      ) : (
        <p>
          {translate('v2broadcast.locked.chat')}
        </p>
      )}
    </div>
  );
};

export default observer(DesktopBroadcastLockedChat);
